import React, { useState, useEffect } from 'react';

import { Table } from 'antd';
import moment from 'moment';

import { getWalletDeposits, getWalletWithdrawals } from '../../common/fetch';
import Coins from '../../components/Coins';
import DataFilter from '../../containers/Dashboard/DataFilter';

const TABLE_TRANSFER_COLUMN = [
    {
        title: 'Coin',
        dataIndex: 'currency',
        key: 'currency',
        render: (currency, { fullname }) => (
            <div className="flex-col">
                <Coins type={currency.toLowerCase()} small={true} />{fullname}
            </div>
        )
    },
    {
        title: 'Type',
        dataIndex: 'type',
        key: 'type',
        render: (type) => (
            <div>
                {type}
            </div>
        )
    },
    {
        title: 'Amount',
        dataIndex: 'amount',
        key: 'amount',
        render: (amount) => <div>{amount}</div>
    },
    {
        title: 'Date',
        dataIndex: 'created_at',
        key: 'created_at',
        render: (created_at) => <div>{moment(created_at).format('DD/MM/YYYY hh:mm a')}</div>
    },
];

const filterOptions = [
    { label: 'All', value: 'all'},
    { label: 'TransactionId', value: 'transaction_id'},
];

const DepositHistory = ({ type }) => {
    const [options, setOptions] = useState('all');
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(50);
    const [currentTablePage, setCurrentPage] = useState(1);
    const [depositData, setDepositData] = useState([]);
    const [withdrawalData, setWithdrawalData] = useState([]);

    useEffect(() => {
        if (type === "deposit") {
            getDeposits();
        } else {
            getWithdrawals();
        }
    }, [type]);

    const getDeposits = async (params = {}, count = 1, pageSize = 50) => {
        let body = {
            ...params,
            page: count,
            limit: pageSize
        }
        try {
            const res = await getWalletDeposits(body);
            if (res.data && res.data.data) {
                setDepositData(res.data.data);
                setPage(count);
                setLimit(pageSize);
            }
        } catch (error) {
            console.error(error);
        }
    };

    const getWithdrawals = async (params = {}, count = 1, pageSize = 50) => {
        let body = {
            ...params,
            page: count,
            limit: pageSize
        }
        try {
            const res = await getWalletWithdrawals(body);
            if (res.data && res.data.data) {
                setWithdrawalData(res.data.data);
                setPage(count);
                setLimit(pageSize);
            }
        } catch (error) {
            console.error(error);
        }
    };

    const pageChange = (count, pageSize) => {
        const pageCount = count % 5 === 0 ? 5 : count % 5;
        const apiPageTemp = Math.floor(count / 5);
        if (limit === pageSize * pageCount && apiPageTemp >= page) {
            if (type === "deposit") {
                getDeposits(
                    page + 1,
                    limit
                );
            } else {
                getWithdrawals(
                    page + 1,
                    limit
                );
            }
        }
        setCurrentPage(count);
    }
    const onClickFilter = (value) => {
        if (value) {
            let queryParams = {}
            if (options === 'all') {
                queryParams = { search: [value] }
            } else {
                queryParams[options] = value;
            }
            if (type === 'deposit') {
                getDeposits(queryParams);
            } else {
                getWithdrawals(queryParams);
            }
        }
    };
    
    const onSelect = (value) => {
        setOptions(value)
    };

    return (
        <div>
            <div className="title-description">
                <h2>
                    <b>{type === 'deposit' ? 'Deposits' : 'Withdrawals'}</b>
                </h2>
                <div>
                    <DataFilter
                        selectOptions={filterOptions}
                        handleSearch={onClickFilter}
                        handleSelect={onSelect}
                    />
                </div>
            </div>
            <div className="table-wrap table-wrapper">
                <Table
                    columns={TABLE_TRANSFER_COLUMN}
                    dataSource={type === "deposit" ? depositData : withdrawalData}
                    rowKey={(data) => {
                        return data.id;
                    }}
                    pagination={{
                        current: currentTablePage,
                        onChange: pageChange
                    }}
                />
            </div>
        </div>
    );
}

export default DepositHistory;
